import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "./Styles/InputStyles";
import Loading from "./Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "react-select";
import Model from "./Model";
import Images from "../Images";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";

const ChangePasswordModal = ({
  setChangePasswordModel,
  changePasswordMutate,
  changePasswordLoading,
}) => {
  const InitialValues = {
    old: "",
    new: "",
    confirm: "",
  };

  const SubmitHandler = (values) => {
    if (changePasswordLoading) return;

    if (values.new.length < 5) {
      return toast.error("Password should be more than 5 characters");
    } else if (values.new !== values.confirm) {
      return toast.error("New & Confirm Password should be same");
    }

    changePasswordMutate({
      newPassword: values?.new,
      oldPassword: values?.old,
    });
  };

  return (
    <Model width={`w-11/12 max-w-xl `} setOpenModel={setChangePasswordModel}>
      <Title>Change Password</Title>

      {changePasswordLoading && <Loading />}

      {!changePasswordLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="old">Current Password</Label>
                <FieldWrapper>
                  <Field
                    type="password"
                    name="old"
                    id="old"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="new">New Password</Label>
                <FieldWrapper>
                  <Field
                    type="password"
                    name="new"
                    id="new"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="confirm">Confirm Password</Label>
                <FieldWrapper>
                  <Field
                    type="password"
                    name="confirm"
                    id="confirm"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-10 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;
const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default ChangePasswordModal;
